module.exports = __webpack_public_path__ + "img/abstract-shapes-12.f488e3b5.svg";